import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import { buildAiAssistantUrl } from 'site-modules/shared/utils/ai-assistant-url';
import { PersonalizedSearchLinkIcon } from './personalized-search-link/personalized-search-link-icon';
import { BaseGlobalSearchLink } from './base-global-search-link';
import { AskAISearchLinkTitle } from './ask-ai-search-link-title';

export const AskAISearchLinkUI = memo(
  ({
    location,
    query = GlobalSearchLinkDefaultProps.query,
    creativeId = GlobalSearchLinkDefaultProps.creativeId,
    isMobile = GlobalSearchLinkDefaultProps.isMobile,
    onLinkClick = GlobalSearchLinkDefaultProps.onLinkClick,
    selectionType = GlobalSearchLinkDefaultProps.selectionType,
    title = GlobalSearchLinkDefaultProps.title,
    fastMatcherData = GlobalSearchLinkDefaultProps.fastMatcherData,
    icon = GlobalSearchLinkDefaultProps.icon,
    label = GlobalSearchLinkDefaultProps.label,
    linkType = GlobalSearchLinkDefaultProps.linkType,
    ...restProps
  }) => {
    const url = buildAiAssistantUrl(location, query ? { message: query } : {});

    return (
      <BaseGlobalSearchLink
        {...restProps}
        location={location}
        query={query}
        creativeId={creativeId}
        isMobile={isMobile}
        onLinkClick={onLinkClick}
        selectionType={selectionType}
        title={title}
        fastMatcherData={fastMatcherData}
        icon={icon}
        label={label}
        linkType={linkType}
        url={url}
        linkThumbComponent={PersonalizedSearchLinkIcon}
        linkTitleComponent={AskAISearchLinkTitle}
        rel="nofollow"
      />
    );
  }
);

AskAISearchLinkUI.displayName = 'AskAISearchLink';

AskAISearchLinkUI.propTypes = {
  ...GlobalSearchLinkPropTypes,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export const AskAISearchLink = connectToModel(AskAISearchLinkUI, {
  location: bindToPath('location', PageModel, null, false),
});
